import React, { useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import PlanoTypography from "./PlanoTypography";

const PlanoLoaderModal = ({ open, setOpen, text = "" }) => {
  // Function to close the loading modal
  const closeLoadingModal = () => {
    setOpen(false);
  };

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
      // Close the loading modal if clicked outside
    >
      <CircularProgress color="inherit" />
      <PlanoTypography
        css={{
          marginLeft: "1rem",
        }}
      >
        {text}
      </PlanoTypography>
    </Backdrop>
  );
};

export default PlanoLoaderModal;
